import React, { useState } from 'react'

import { getFormattedCreatedTime, getTooltipTimestamp } from 'utils/communities.utils'
import { getTimeLeftObject } from 'utils/dateTime.utils'

import './post-time.scss'

const PostTime = ({ createdTime, editedTime, edited }) => {
  const [showTimestamp, setShowTimeStamp] = useState(false)

  const date = edited ? editedTime : createdTime

  const { days } = getTimeLeftObject(date, true)

  const isNotBiggerThanDay = days < 1

  return (
    <div className='post-time' tabIndex={0} onBlur={() => setShowTimeStamp(false)}>
      <div className='post-time__number' onClick={() => setShowTimeStamp(true)}>
        {edited
          ? `${I18n.t('react.shared.common.edited')} ${getFormattedCreatedTime(date)}`
          : `${getFormattedCreatedTime(date)}`}
      </div>
      {showTimestamp && isNotBiggerThanDay && (
        <div className='post-time__timestamp-tooltip'>{getTooltipTimestamp(date)}</div>
      )}
    </div>
  )
}

export default PostTime
